import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Pagination, Supplier } from "@/v2/types";

export default async function FindAllPendingSupplier({
    limit,
    skip,
    search,
    filter,
}: {
    skip?: number;
    limit?: number;
    search?: string;
    filter?: Record<string, string>;
}): Promise<{ data: Supplier[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: "/vendors/pending-onboarding",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
            ...filter,
        },
    });

    return res.data;
}
